import React from 'react'
import { Feather, RefreshCw, Sun, Thermometer, Zap } from 'react-feather'
import { Box, Divider, makeStyles } from '@material-ui/core'
import { BuildingFragment } from '../../../generated/graphql'
import { IndicatorIcon } from './IndicatorIcon'
import { useIndicatorIcons } from '../../../indicator-icons/use-indicator-icons'

const useStyles = makeStyles((theme) => ({
  divider: {
    height: theme.spacing(6),
    width: 2,
    margin: theme.spacing(1),
  },
}))

type Props = {
  building: BuildingFragment
}

export function IndicatorIcons({ building }: Props): React.ReactElement {
  const { getIndicatorIconsForBuilding } = useIndicatorIcons()
  const classes = useStyles()

  const {
    hasGreenEnergy,
    hasEnvironmentalHeat,
    hasWasteEnergy,
    hasLocalWaterGrid,
    hasLocalElectricity,
  } = getIndicatorIconsForBuilding(building)

  return (
    <Box display="flex">
      <IndicatorIcon icon={<Feather />} isActive={hasEnvironmentalHeat} />
      <IndicatorIcon icon={<Sun />} isActive={hasGreenEnergy} />
      <IndicatorIcon icon={<RefreshCw />} isActive={hasWasteEnergy} />
      <Divider orientation="vertical" className={classes.divider} />
      <IndicatorIcon icon={<Thermometer />} isActive={hasLocalWaterGrid} />
      <IndicatorIcon icon={<Zap />} isActive={hasLocalElectricity} />
    </Box>
  )
}
